(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initToggleNextBlock();
  });

  function initToggleNextBlock() {
    var triggers = document.querySelectorAll('.wine-title, .main-title');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var content = trigger.nextElementSibling;
      if (!content) return;

      // зберігаємо початкові стилі контенту
      if (!content.dataset.initialized) {
        content.dataset.initialPadding = content.style.padding || '';
        content.dataset.initialMargin = content.style.margin || '';
        content.dataset.initialized = 'true';
      }

      // зберігаємо початкові стилі заголовка
      if (!trigger.dataset.initialized) {
        trigger.dataset.initialPadding = trigger.style.padding || '';
        trigger.dataset.initialMargin = trigger.style.margin || '';
        trigger.dataset.initialized = 'true';
      }

      trigger.addEventListener('click', function () {
        toggleBlock(trigger, content);
      });
    });
  }

  function toggleBlock(trigger, content) {
    var isCollapsed = content.classList.contains('is-collapsed');
    var icon = trigger.querySelector('svg');

    if (isCollapsed) {
      /* =====================
       * 🔽 РОЗГОРНУТИ
       * ===================== */
      content.classList.remove('is-collapsed');
      console.log('content.scrollHeight', content.scrollHeight);
      
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.padding = content.dataset.initialPadding;
      content.style.margin = content.dataset.initialMargin;

      trigger.style.padding = trigger.dataset.initialPadding;
      trigger.style.margin = trigger.dataset.initialMargin;

      if (icon) icon.style.transform = 'rotate(0deg)';
        content.style.maxHeight = '';
      // очистити max-height після анімації
    //   setTimeout(function () {
    //     content.style.maxHeight = '';
    //   }, 500);
    } else {
      /* =====================
       * 🔼 ЗГОРНУТИ
       * ===================== */
      content.style.maxHeight = content.scrollHeight + 'px';

      requestAnimationFrame(function () {
        content.classList.add('is-collapsed');
        content.style.maxHeight = '0px';
        content.style.padding = '0';
        content.style.margin = '0';

        trigger.style.padding = '0';
        trigger.style.margin = '0';
      });

      if (icon) icon.style.transform = 'rotate(180deg)';
    }
  }

  const headingSelectors = [
    '.wb-modal-title',
    'h2[data-upcart-chunk="header-title-content"]',
    '.upcart-public-component-product-tile__product-title'
  ];

  function replaceDynamicHeading(heading) {
    if (!/^H[1-6]$/.test(heading.tagName)) return;

    const div = document.createElement('div');
    const computedStyles = window.getComputedStyle(heading);

    Array.from(heading.attributes).forEach(function (attribute) {
      div.setAttribute(attribute.name, attribute.value);
    });

    div.dataset.originalTag = heading.tagName.toLowerCase();

    for (let index = 0; index < computedStyles.length; index += 1) {
      const property = computedStyles.item(index);
      div.style.setProperty(
        property,
        computedStyles.getPropertyValue(property),
        computedStyles.getPropertyPriority(property)
      );
    }

    while (heading.firstChild) {
      div.appendChild(heading.firstChild);
    }

    heading.replaceWith(div);
  }

  function findDynamicHeadings(root) {
    headingSelectors.forEach(function (selector) {
      if (root.matches && root.matches(selector)) {
        replaceDynamicHeading(root);
      }

      if (root.querySelectorAll) {
        root.querySelectorAll(selector).forEach(replaceDynamicHeading);
      }
    });
  }

  const headingObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          findDynamicHeadings(node);
        }
      });
    });
  });

  findDynamicHeadings(document);

  headingObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();
